module.exports = __webpack_public_path__ + "img/df93838.svg";